import React from 'react';
import { connect } from 'react-redux';
import { ImportExportIcon } from './../../../themes/icons';
import { Section, Content, Main } from './../../../components/includes/container';
import { ToolbarPrimary } from './../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../components/includes/breadcrumb';
import { Table, Thead, Tbody, Row, Cell, Tresponsive, Ttolbar } from './../../../components/includes/ui/table';
import { Btn } from './../../../components/includes/ui';

import API from './../../../config/api';

const rows = [
  { id: 'name', sort: true, numeric: false, disablePadding: false, label: 'Nombre' },
  { id: 'actions', sort: false, numeric: true, disablePadding: false, label: 'Acciones', width:120, minWidth: 120 }
];

class Data extends React.Component {

  constructor(props){
    super(props);
    this.state = {};
  }

  componentDidMount(){

  }


  render() {

    return (
      <Section>

        <ToolbarPrimary title="Data"/>
        <BreadcrumbItem to='/data'>Data</BreadcrumbItem>

        <Content>
          <Main>

            <Ttolbar title="Data"/>

            <div>

              <Tresponsive enabledActions>
                <Table>

                  <Thead rows={ rows }/>

                  <Tbody>

                    <Row>
                      <Cell>Ibero</Cell>
                      <Cell numeric>
                        <Btn color="primary" size="xsmall" target="_blank" href={ `${ API.endpoint.services }/p/data/download/ibero` }>
                          <ImportExportIcon fontSize="small"/>
                        </Btn>
                      </Cell>
                    </Row>

                  </Tbody>
                </Table>
              </Tresponsive>

            </div>

          </Main>
        </Content>
      </Section>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Data);
